import axios from "./axios"
import { server, marketing } from "./constants"

const RETRY_INTERVAL = 50; // milliseconds
const MAX_RETRIES = 50; // maximum number of retries

/**
 * Add an activity log with lock mechanism
 */
const addActivity = async ({ target, action, ref, interval }) => {
  if (!ref || !interval || !target || !action) {
    return;
  }

  let retries = 0;
  const acquireLock = () => {
    const lock = sessionStorage.getItem(server.ACTIVITY_LOGS_LOCK);
    if (lock) {
      return false;
    }
    sessionStorage.setItem(server.ACTIVITY_LOGS_LOCK, "1");
    return true;
  };
  const releaseLock = () => {
    sessionStorage.removeItem(server.ACTIVITY_LOGS_LOCK);
  };
  const sleep = (time) => new Promise((r) => setTimeout(r, time));

  while (retries < MAX_RETRIES) {
    if (acquireLock()) {
      try {
        // Load the logs
        const rawLogs = sessionStorage.getItem(server.ACTIVITY_LOGS);
        const logs = JSON.parse(rawLogs) || {};
        const key = `${target}-${action}-${ref}`;

        // Update the logs
        if (logs[key]) {
          logs[key].interval += interval;
        } else {
          logs[key] = { target, action, ref, interval };
        }

        // Save the logs
        sessionStorage.setItem(
          server.ACTIVITY_LOGS,
          JSON.stringify(logs)
        );
        return;
      } finally {
        releaseLock();
      }
    } else {
      retries += 1;
      await sleep(RETRY_INTERVAL);
    }
  }

  throw new Error("Failed to acquire lock after maximum retries");
};


/**
 * Flush the activity logs
 */
const flushActivityLogs = async () => {
  // Load the logs
  const rawLogs = sessionStorage.getItem(server.ACTIVITY_LOGS)
  const logs = JSON.parse(rawLogs) || {}
  const arrLogs = Object.values(logs)
  // console.log(arrLogs)

  // Check if logs length is lt 24, if so, return
  if (arrLogs.length < 24) {
    return
  }

  // Push the logs
  const response = await axios.post(marketing.LOGS_ACTIVITY_URL, arrLogs)
  if (response.status !== 200) {
    // console.error("Failed to flush")
    return
  }

  // FIXME: If ACTIVITY_LOGS gets updated while the request is being made, the logs will be lost
  // Clear the logs
  sessionStorage.removeItem(server.ACTIVITY_LOGS)
}

// =================================================================================================
// Wraper for the above functions

/**
 * Mark the product as seen including the interval
 */
const markSeenProduct = async ({ id, interval }) => {
  if (id && interval) {
    addActivity({ ref: id, interval, target: "products", action: "seen" })
  }
}

/**
 * Mark the product with engagement including the interval
 */
const markEngagedProduct = async ({ id, interval }) => {
  if (id && interval) {
    addActivity({ ref: id, interval, target: "products", action: "engaged" })
  }
}

/**
 * Mark the ad as seen including the interval
 */
const markSeenAds = async ({ id, interval }) => {
  if (id && interval) {
    addActivity({ ref: id, interval, target: "ads", action: "seen" })
  }
}

/**
 * Mark the ad with engagement including the interval
 */
const markClickAds = async ({ id, interval }) => {
  if (id && interval) {
    addActivity({ ref: id, interval, target: "ads", action: "click" })
  }
}

export default {
  flushActivityLogs,
  markSeenProduct,
  markEngagedProduct,
  markSeenAds,
  markClickAds
}
